import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { bopsApi } from '@Network';

interface UpdatePermissionsParams {
  email: string;
  permissions: string[];
}

const useUserPermissions = (email: string | null) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['user-permissions', email],
    queryFn: () => bopsApi.getUserPermissions(email || ''),
    enabled: !!email,
  });

  const updatePermissions = useMutation({
    mutationFn: ({ email: userEmail, permissions }: UpdatePermissionsParams) =>
      bopsApi.updateUserPermissions(userEmail, permissions),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['user-permissions', variables.email],
      });
    },
  });

  return {
    query,
    updatePermissions,
  };
};

export default useUserPermissions;
